import axios from 'axios';

const axiosInterceptor = axios.interceptors.request.use(function (config) {
    console.log("intercepted axios request!!!");
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Response interceptor to handle authentication errors
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle authentication errors
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            localStorage.removeItem('some-key');
            window.location.href = '/signin';
            return Promise.reject(error);
        }
        
        // Handle "API route not found" errors which often indicate expired sessions
        if (error.response && error.response.data && 
            typeof error.response.data === 'string' && 
            error.response.data.includes('API route not found')) {
            localStorage.removeItem('some-key');
            window.location.href = '/signin';
            return Promise.reject(error);
        }
        
        return Promise.reject(error);
    }
);

export default axiosInterceptor;